export const MIME_TYPE_MAPPER = {
  csv: 'text/csv',
  json: 'application/json',
  pdf: 'application/pdf',
} as const

export type CodeFilesFormat = keyof typeof MIME_TYPE_MAPPER
